<template>
    <div>
        <div class="top-header top-header__text">
            <h1>{{ variation === 'marathon' ? 'Maraton' : 'Registreringer' }}</h1>
        </div>

        <div class="page__content page__content--toplist">
            <form @submit.prevent id="toplist-filter">
                <div class="radio radio--regions" v-if="filters.regions.length">
                    <label><input type="radio" name="region" value="" v-model="region"><span>Alle</span></label>
                    <label v-for="r in filters.regions" :key="r.id">
                        <input type="radio" name="region" :value="r.id" v-model="region"><span>{{ r.name }}</span>
                    </label>
                </div>
                <div class="select select--competitions select--municipality" v-if="filters.municipalities.length">
                    <select v-model="municipality">
                        <option value="">Velg kommune</option>
                        <option v-for="m in filters.municipalities" :key="m.id" :value="m.id">{{ m.txt }}</option>
                    </select>
                </div>
                <div class="select select--competitions">
                    <select v-model="competition">
                        <option v-for="c in filters.competitions" :key="c.id" :value="c.id">{{ c.name }}</option>
                    </select>
                </div>
                <input type="text" class="searchfield" v-model="query" placeholder="Søk etter navn">
            </form>

            <div id="toplist-loading" v-if="initialLoading"><div class="toplist__spinner"></div></div>

            <template v-else>
                <div class="toplist-back"><a href="#" class="action" @click.prevent="$emit('back')">&laquo; Tilbake</a></div>

                <div class="toplist__content" :class="{ 'toplist__content--loading': loading }">
                    <div class="toplist__loading-overlay" v-if="loading"><div class="toplist__spinner"></div></div>

                    <template v-if="toplist.length">
                        <div class="table__summary-wrapper">
                            <div class="table__summary">
                                <div class="table__summary-item hero__stat">
                                    <div class="hero__statcount">{{ regFormat(summary.reg_count) }}</div>
                                    <div class="hero__stat-text">Registreringer</div>
                                </div>
                                <div class="table__summary-item hero__stat">
                                    <div class="hero__statcount">{{ regFormat(summary.people_count) }}</div>
                                    <div class="hero__stat-text">Deltakere</div>
                                </div>
                            </div>
                            <div class="table__summary" v-if="summary.anon_people_count">
                                <div class="table__summary-item">Av disse var {{ regFormat(summary.anon_reg_count) }} registreringer gjort av {{ regFormat(summary.anon_people_count) }} anonyme brukere</div>
                            </div>
                        </div>

                        <div class="table">
                            <table>
                            <thead>
                                <tr>
                                    <th class="table__header--ranking">#</th>
                                    <th class="table__header--name">Deltaker</th>
                                    <template v-if="variation === 'marathon'">
                                        <th class="table__header--reg"><a href="#" class="table__sorting" :class="{ 'table__sorting--active': order === 'visits' }" @click.prevent="order = 'visits'">Reg.{{ municipalityName ? ' i ' + municipalityName : '' }}<i v-if="order === 'visits'" class="pi pi-sort-amount-down"></i></a></th>
                                        <th class="table__header--targets"><a href="#" class="table__sorting" :class="{ 'table__sorting--active': order === 'targets' }" @click.prevent="order = 'targets'">Turmål{{ municipalityName ? ' i ' + municipalityName : '' }}<i v-if="order === 'targets'" class="pi pi-sort-amount-down"></i></a></th>
                                        <template v-if="municipality">
                                            <th class="table__header--reg">Reg. totalt</th>
                                            <th class="table__header--targets">Turmål totalt</th>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <th class="table__header--targets"><a href="#" class="table__sorting" :class="{ 'table__sorting--active': order === 'targets' }" @click.prevent="order = 'targets'">Turmål{{ municipalityName ? ' i ' + municipalityName : '' }}<i v-if="order === 'targets'" class="pi pi-sort-amount-down"></i></a></th>
                                        <th class="table__header--reg"><a href="#" class="table__sorting" :class="{ 'table__sorting--active': order === 'visits' }" @click.prevent="order = 'visits'">Reg.{{ municipalityName ? ' i ' + municipalityName : '' }}<i v-if="order === 'visits'" class="pi pi-sort-amount-down"></i></a></th>
                                        <template v-if="municipality">
                                            <th class="table__header--targets">Turmål totalt</th>
                                            <th class="table__header--reg">Reg. totalt</th>
                                        </template>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(entry, index) in toplist" :key="entry.person_id"
                                    class="table__entry"
                                    :class="{ 'table__entry--first': index === 0, 'table__entry--last': index === toplist.length - 1, 'table__entry--user': (personId && entry.person_id === personId) || isFamilyMember(entry.person_id) }">
                                    <td class="table__ranking table__num">{{ entry.ranking }}</td>
                                    <td class="table__name">{{ entry.name }}</td>
                                    <template v-if="variation === 'marathon'">
                                        <td class="table__reg table__num" :class="{ 'table__num--current': order === 'visits' }">{{ entry.n_tur }}</td>
                                        <td class="table__targets table__num" :class="{ 'table__num--current': order === 'targets' }">{{ entry.n_targets }}</td>
                                        <template v-if="municipality">
                                            <td class="table__reg table__num">{{ entry.stats.n_regs }}</td>
                                            <td class="table__targets table__num">{{ entry.stats.n_routes }}</td>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <td class="table__targets table__num" :class="{ 'table__num--current': order === 'targets' }">{{ entry.n_targets }}</td>
                                        <td class="table__reg table__num" :class="{ 'table__num--current': order === 'visits' }">{{ entry.n_tur }}</td>
                                        <template v-if="municipality">
                                            <td class="table__targets table__num">{{ entry.stats.n_routes }}</td>
                                            <td class="table__reg table__num">{{ entry.stats.n_regs }}</td>
                                        </template>
                                    </template>
                                </tr>
                                <template v-if="unlistedOwnAndFamilyEntries.length">
                                    <tr>
                                        <td></td>
                                        <td style="font-size: 0.1em;">&nbsp;</td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr v-for="entry in unlistedOwnAndFamilyEntries" :key="entry.person_id" class="table__entry--user">
                                        <td class="table__ranking table__num">{{ entry.ranking }}</td>
                                        <td class="table__name">
                                            <a v-if="entry.position" href="#" class="table__secondary-link" @click.prevent="goToPosition(entry)">{{ entry.name }}</a>
                                            <template v-else>{{ entry.name }}</template>
                                            <span v-if="entry.anonymous" class="toplist__anon-notice">{{ entry.isSelf ? 'Du er registrert' : 'Registrert' }} som anonym, og vises ikke i topplisten.</span>
                                        </td>
                                        <td class="table__targets table__num">{{ entry.n_targets }}</td>
                                        <td class="table__reg table__num">{{ entry.n_tur }}</td>
                                        <template v-if="municipality">
                                            <td class="table__targets table__num">{{ entry.stats.n_routes }}</td>
                                            <td class="table__reg table__num">{{ entry.stats.n_regs }}</td>
                                        </template>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                        <ToplistPager :current-page="pagination.current_page" :last-page="pagination.last_page" @change="goToPage" />
                    </div>
                    </template>
                    <div class="regtable__empty" v-else>Ingen registreringer</div>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import { regFormat } from '../config/format.js';
import ToplistPager from './ToplistPager.vue';

const props = defineProps({
    variation: { type: String, required: true },
    competitionId: { type: Number, default: null },
    personId: { type: Number, default: null },
});

defineEmits(['back']);

const params = new URLSearchParams(window.location.search);

const region = ref(params.get('region') || '');
const municipality = ref(params.get('municipality') || '');
const competition = ref(params.get('competition') ? Number(params.get('competition')) : (props.competitionId || ''));
const query = ref(params.get('q') || '');
// Marathon ranks by registrations, the regular toplist by turmål.
const defaultOrder = props.variation === 'marathon' ? 'visits' : 'targets';
const order = ref(params.get('order') || defaultOrder);
const page = ref(params.get('page') ? Number(params.get('page')) : 1);

const loading = ref(true);
const initialLoading = ref(true);
const toplist = ref([]);
const pagination = ref({ current_page: 1, last_page: 1, total: 0, per_page: 25 });
const summary = ref({ people_count: 0, reg_count: 0, anon_people_count: 0, anon_reg_count: 0 });
const userEntry = ref(null);
const familyEntries = ref([]);
const filters = ref({ municipalities: [], regions: [], competitions: [], competition: null });

const municipalityName = computed(() => {
    const match = filters.value.municipalities.find((m) => String(m.id) === String(municipality.value));
    return match ? match.txt : '';
});

function isFamilyMember(personId) {
    return familyEntries.value.some((entry) => entry.person_id === personId);
}

// The user's own entry plus their family's, combined and sorted by rank
// together - not "you first, then family" - and with anyone already visible
// on the current page dropped (they're already highlighted in place via
// isFamilyMember()/personId above, matching entry.person_id).
const unlistedOwnAndFamilyEntries = computed(() => {
    const entries = [];
    if (userEntry.value && !toplist.value.some((row) => row.person_id === props.personId)) {
        entries.push({ ...userEntry.value, isSelf: true });
    }
    familyEntries.value.forEach((entry) => {
        if (!toplist.value.some((row) => row.person_id === entry.person_id)) {
            entries.push({ ...entry, isSelf: false });
        }
    });
    return entries.sort((a, b) => a.ranking - b.ranking);
});

let requestToken = 0;
let userEntryToken = 0;
let searchDebounce = null;

async function load() {
    const token = ++requestToken;
    loading.value = true;

    const search = new URLSearchParams();
    if (props.variation === 'marathon') search.set('variation', 'marathon');
    if (region.value) search.set('region', region.value);
    if (municipality.value) search.set('municipality', municipality.value);
    if (competition.value) search.set('competition', competition.value);
    if (query.value) search.set('q', query.value);
    search.set('order', order.value);
    search.set('page', page.value);

    syncUrl(search);

    try {
        const response = await fetch('/xhr/frontend/toplists/competition/registrations?' + search.toString(), {
            headers: { Accept: 'application/json' },
        });
        if (response.ok && token === requestToken) {
            const data = await response.json();
            toplist.value = data.toplist?.data || [];
            pagination.value = {
                current_page: data.toplist?.current_page || 1,
                last_page: data.toplist?.last_page || 1,
                total: data.toplist?.total || 0,
                per_page: data.toplist?.per_page || 25,
            };
            summary.value = data.summary || summary.value;
            filters.value = data.filters || filters.value;
        }
    } catch (e) {
        // Leave the previous state in place.
    } finally {
        if (token === requestToken) {
            loading.value = false;
            initialLoading.value = false;
        }
    }
}

// Split from load() so the (person-independent) main list request stays
// cacheable - "my rank" doesn't depend on page or search query, only on the
// same filters that change the ranking itself, so it's fetched separately.
async function loadUserEntry() {
    const token = ++userEntryToken;

    const search = new URLSearchParams();
    if (props.variation === 'marathon') search.set('variation', 'marathon');
    if (region.value) search.set('region', region.value);
    if (municipality.value) search.set('municipality', municipality.value);
    if (competition.value) search.set('competition', competition.value);
    search.set('order', order.value);

    try {
        const response = await fetch('/xhr/frontend/toplists/competition/registrations/me?' + search.toString(), {
            headers: { Accept: 'application/json' },
        });
        if (response.ok && token === userEntryToken) {
            const data = await response.json();
            userEntry.value = data.user_entry || null;
            familyEntries.value = data.family_entries || [];
        }
    } catch (e) {
        // Leave the previous state in place.
    }
}

function syncUrl(search) {
    search.set('type', props.variation);
    history.replaceState({}, '', '/topplister?' + search.toString());
}

function goToPage(next) {
    page.value = next;
}

// entry.position (a gapless 1-indexed position, unlike ranking which ties
// can share and which can therefore span a page boundary) is only
// meaningful against the unfiltered list toplist() paginates when no search
// is active - clearing an active query re-triggers its own watcher below,
// so this waits a tick for that debounce to get (re)scheduled and then
// cancels it, rather than letting it fire later and reset the page this
// just navigated to. Shared by both the user's own row and each family
// member's row.
async function goToPosition(entry) {
    if (!entry?.position) {
        return;
    }
    if (query.value) {
        query.value = '';
        await nextTick();
        clearTimeout(searchDebounce);
    }
    page.value = Math.ceil(entry.position / pagination.value.per_page);
    load();
}

// Changing municipality (including back to all) resets the sort to the default.
// Registered before the refetch watcher below so both changes land in a single load().
watch(municipality, () => {
    order.value = defaultOrder;
});

// Any filter change refetches and resets to page 1, except a direct page change.
watch([region, municipality, competition, order], () => {
    page.value = 1;
    load();
    loadUserEntry();
});

watch(page, () => load());

watch(query, () => {
    clearTimeout(searchDebounce);
    searchDebounce = setTimeout(() => {
        page.value = 1;
        load();
    }, 300);
});

onMounted(() => {
    load();
    loadUserEntry();
});
</script>
